import script from "./OrderConfirm.vue?vue&type=script&setup=true&lang=js"
export * from "./OrderConfirm.vue?vue&type=script&setup=true&lang=js"

import "./OrderConfirm.vue?vue&type=style&index=0&id=2527d29d&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2527d29d"]])

export default __exports__